export default "__VITE_ASSET__C1l0tO7E__"